import { render, staticRenderFns } from "./ClipboardTextField.vue?vue&type=template&id=18288987"
import script from "./ClipboardTextField.vue?vue&type=script&lang=js"
export * from "./ClipboardTextField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18288987')) {
      api.createRecord('18288987', component.options)
    } else {
      api.reload('18288987', component.options)
    }
    module.hot.accept("./ClipboardTextField.vue?vue&type=template&id=18288987", function () {
      api.rerender('18288987', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ClipboardTextField.vue"
export default component.exports